import React from 'react';
import { BigPlayButton, ControlBar, LoadingSpinner, Player, PlayToggle } from "video-react"
import "video-react/dist/video-react.css"
import { useEffect, useState } from "react"
import {PropTypes} from "prop-types"

export function VideoPlayer({
    src,
    onPlayerChange = () => { },
    onChange = () => { },
    startTime = undefined,
}) {
    const [player, setPlayer] = useState(undefined)
    const [playerState, setPlayerState] = useState(undefined)

    useEffect(() => {
        if (playerState) {
            onChange(playerState)
        }
    }, [playerState])

    useEffect(() => {
        onPlayerChange(player)

        if (player) {
            player.subscribeToStateChange(setPlayerState)
        }
    }, [player])

    return (
        <div className={"video-player overflow-hidden rounded-lg h-[392.75px] md:h-[492.75px] max-w-[657px]"} style={{ width: "100%" }}>
            <Player
                ref={(player) => {
                    setPlayer(player)
                }}
                startTime={startTime}
                // className="w-[100%] h-[100%] "p-2 max-w-[876px] m-auto
                fluid={false}
                aspectRatio={"16:9"}
                width={"100%"}
                height={"100%"}
            >
                <source src={src} />
                <BigPlayButton position="center" />
                <LoadingSpinner />
                <ControlBar autoHide={false}>
                    <PlayToggle />
                </ControlBar>
            </Player>
            {/* <video src={src} autoPlay controls ></video> */}
        </div>
    )
}
VideoPlayer.propTypes = {
    src: PropTypes.string.isRequired, // Assuming src is a URL or path to the video file
    onPlayerChange: PropTypes.func,
    onChange: PropTypes.func,
    startTime: PropTypes.number, // Assuming startTime is a number
};
